function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var makeMenuItemStyles = function makeMenuItemStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: _objectSpread(_objectSpread(_objectSpread({
          boxShadow: "0px 0px 0px 2px ".concat(primitives.colors.detail.transparent, ", 0px 0px 0px 1px ").concat(primitives.colors.detail.transparent),
          color: tokens.colors["text-on-background"],
          minHeight: "auto",
          paddingTop: primitives.spacings["2"],
          paddingBottom: primitives.spacings["2"],
          position: "relative",
          whiteSpace: "normal",
          marginLeft: ".125rem",
          marginRight: ".125rem",
          paddingLeft: primitives.spacings["3"]
        }, tokens.typography["short-copy-medium"]), {}, {
          "& .DhigSelect--checkedIcon": {
            position: "absolute",
            right: primitives.spacings["2"]
          },
          "& .DhigSelect--option": {
            marginRight: primitives.spacings["6"],
            width: "100%"
          },
          "&:hover": _objectSpread({
            backgroundColor: tokens.colors["hover-fill-subtle"]
          }, tokens.transitions["state-blur"]),
          "&:focus-visible": {
            boxShadow: tokens.effects["focus-ring-thin"],
            backgroundColor: primitives.colors.detail.transparent
          },
          "&.Mui-selected": {
            backgroundColor: tokens.colors["activated-fill-subtle"],
            "&.Mui-focusVisible, &:focus, &:focus-visible": {
              backgroundColor: tokens.colors["activated-fill-subtle"],
              "&:hover": {
                backgroundColor: tokens.colors["activated-hover-fill-subtle"]
              },
              "&:active": {
                backgroundColor: tokens.colors["activated-pressed-fill-subtle"]
              }
            }
          },
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["5"]),
          border: "2px solid ".concat(primitives.colors.detail.transparent)
        }, tokens.transitions["state-blur"]), {}, {
          "&:hover, &:active, &:focus-visible": _objectSpread({}, tokens.transitions["state-activate"]),
          "&:active": {
            backgroundColor: tokens.colors["pressed-fill-subtle"],
            boxShadow: "0px 0px 0px 2px ".concat(primitives.colors.detail.transparent)
          },
          "&.DhigSplitButton--menuItem--focused": {
            backgroundColor: primitives.colors.detail.transparent,
            "&:hover": {
              backgroundColor: tokens.colors["hover-fill-subtle"]
            },
            "&:active": {
              backgroundColor: tokens.colors["pressed-fill-subtle"]
            }
          },
          '& [class*="MuiSvgIcon-root"]': {
            paddingRight: primitives.spacings["2"]
          },
          "& .DhigSplitButton--icon--checkmark": {
            paddingLeft: primitives.spacings["3"],
            paddingRight: primitives.spacings["0"],
            marginLeft: "auto",
            width: primitives.spacings["4"]
          },
          "& .MuiTypography-root": {
            color: tokens.colors["ink-on-background"]
          }
        })
      }
    }
  };
};